module.exports = __webpack_public_path__ + "img/sureprep.494baf7f.jpeg";